import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ZipService } from 'src/app/shared/services/viaCep.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { signal } from '@angular/core';
import { ModalComponent, ModalResult } from '@michelin/theme';
import { TireImageDto } from 'src/app/shared/models/tire.dto';
import { VehicleDTO } from 'src/app/shared/models/vehicle.dto';
import { DocumentService } from 'src/app/shared/services/document.service';
import { STATES_OF_BRAZIL } from 'src/app/shared/data/state';
import { BusinessUnitDto } from 'src/app/shared/models/business-unit.dto';
import { BusinessUnitService } from 'src/app/shared/services/business-unit/business-unit.service';
import { RoadService } from 'src/app/shared/services/road/road.service';
import { RoadDto } from 'src/app/shared/models/road.dto';
import { FrequentUseService } from 'src/app/shared/services/frequent-use/frequent-use.service';
import { FrequentUseDto } from 'src/app/shared/models/frequent-use.dto';
import { PwSacDto } from 'src/app/shared/models/pw-sac.dto';
import { PwSacBaseComponent } from './pw-sac-base.component';
import { CustomerAllegationService } from 'src/app/shared/services/customer-allegation/customer-allegation.service';
import { PwSacService } from 'src/app/shared/services/pw-sac/pw-sac.service';
import { VehicleBrandService } from 'src/app/shared/services/vehicle-brand/vehicle-brand.service';
import { PwProductService } from 'src/app/shared/services/pw-product/pw-product.service';
import { PWProductDto } from 'src/app/shared/models/pw-product.dto';
import { PWSacResponseDto } from 'src/app/shared/models/pw-sac-response.dto';


declare const grecaptcha: any;

declare global {
  interface Window {
    recaptchaOnload: () => void;
  }
}


@Component({
  templateUrl: 'pw-sac.component.html',
  imports: [SharedModule, ReactiveFormsModule, NgxMaskDirective, NgxMaskPipe],
  providers: [provideNgxMask()],
  styleUrls: ['./pw-sac.component.scss']
})

export class PwSacComponent extends PwSacBaseComponent implements OnInit {

  @ViewChild('myModal') myModal!: ModalComponent;
  @ViewChild('contentModal') contentModal!: TemplateRef<any>;
  @ViewChild('privacyPolicyModal') privacyPolicyModal!: TemplateRef<any>;

  pwForm: FormGroup;
  cpfCnpjMask = '000.000.000-00||00.000.000/0000-00'
  handleZipCode: boolean = false;
  handleOpenPat: boolean = false;
  isLoadingZipCode: boolean = false;
  isLoadingDocument: boolean = false;
  isLoadingBrands: boolean = false;

  msgFeedback: boolean = false;
  numberPAT: string;

  remainingCharacters = 230;
  remainingAdditionalInfoCharacters = 500;
  readonly maxLengthAdditionalInfoCharacters = 500;
  readonly maxLength = 230;

  addInfoLabel = 'Informações Adicionais (opcional)';

  //siteKey = '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'; // TESTE
  siteKey = '6Lf_8E8sAAAAAOLTIu-Lq81NLmMHxQ6E1WuzzrQE'

  privacyAccepted: boolean = false;
  captchaVerified: boolean = false;
  captchaMinimalist: boolean = false;
  formProgress: number = 0;
  isSubmitting: boolean = false;

  tires = signal<TireImageDto[]>([]);
  selectedTireIndex = signal<number | null>(null);
  states = STATES_OF_BRAZIL;
  businessUnitList: BusinessUnitDto[] = [];
  roadList: RoadDto[] = [];
  frequentUseList: FrequentUseDto[] = [];

    @ViewChild('captchaContainer', { static: false })
    captchaContainer!: ElementRef<HTMLDivElement>;

    private captchaWidgetId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    private documentService: DocumentService,
    private pwService: PwSacService,
    private pwProductService: PwProductService,    
    businessUnitService: BusinessUnitService,
    roadService: RoadService,
    frequentUseService: FrequentUseService,
    zipService: ZipService,
    customerAllegationService: CustomerAllegationService,
    vehicleBrandService: VehicleBrandService,    
  ) {
    super(
      businessUnitService,
      roadService,
      frequentUseService,
      zipService,
      customerAllegationService,
      vehicleBrandService);

    this.resetTires();
    this.loadBusinessUnit();
    this.loadRoadList();
    this.loadFrequentUseList();

  }


  ngOnInit() {

    this.pwForm = this.fb.group({
      customer: this.fb.group({
        document: ['', [Validators.required]],
        name: ['', [Validators.required, Validators.minLength(3)]],
        email: ['', [Validators.required, Validators.email]],
        phone: ['', [Validators.required]],
      }),
      address: this.fb.group({
        zipcode: ['', [Validators.required]],
        state: ['', [Validators.required]],
        city: ['', [Validators.required]],
        neighborhood: ['', [Validators.required]],
        street: ['', [Validators.required]],
        number: ['', [Validators.required]],
        complement: [''],
      }),
      vehicle: this.fb.group({
        businessUnit: ['', [Validators.required]],
        road: ['', [Validators.required]],
        brand: ['', [Validators.required]],
        model: ['', [Validators.required]],
        year: ['', [Validators.required]],
        km: ['', [Validators.required]],
        frequentUse: ['', [Validators.required]],
        pwSpecial: ['N', [Validators.required]],
      }),
      allegation: this.fb.group({
        description: ['', [Validators.required]],
        pwSpecial: ['N', [Validators.required]],
      }),
      productQuantity: [''],
      acceptTerm: [false],
      tires: this.fb.array([]),
      recaptcha: ['', Validators.required]
    });


    this.tiresArray.push(this.createTireFormGroup());
    this.onZipCodeChange();

    this.pwForm.get('allegation.description')?.valueChanges.subscribe(() => {
      this.updateCountdown();
    });

    this.updateCountdown();

    // callback global chamado pelo script api.js?onload=recaptchaOnload
    window.recaptchaOnload = () => {
      this.renderCaptchaIfPossible();
    };
  }

   ngAfterViewInit(): void {
    this.renderCaptchaIfPossible();
    // Tentar renderizar novamente após um delay
    setTimeout(() => {
      this.renderCaptchaIfPossible();
    }, 1000);
  }


  get maxTiresAllowed(): number {
    const businessUnit = this.pwForm?.get('vehicle.businessUnit')?.value as BusinessUnitDto;
    return businessUnit?.id === '2R' ? 2 : 4;
  }

  changeBusinessUnit() {
    this.loadCustomerAllegation();
    this.loadVehicleBrand();
    const max = this.maxTiresAllowed;
    while (this.tiresArray.length > max) {
      this.tiresArray.removeAt(this.tiresArray.length - 1);
    }
    this.updateProductQuantity();
  }

  onPrivacyChange(checked: boolean) {
    this.pwForm.get('acceptTerm')?.setValue(checked);
    this.pwForm.get('acceptTerm')?.markAsTouched();    
  }

  create() {

    if (this.pwForm.invalid || this.isSubmitting) {
      return;
    }
    
    this.isSubmitting = true;
    
    const tiresArray = this.pwForm.get('tires') as FormArray;
    const quantidadeDePneus = tiresArray.length;
    this.pwForm.get('productQuantity')?.setValue(quantidadeDePneus);
    
    Object.keys(this.pwForm.controls).forEach(controlName => {
      const control = this.pwForm.get(controlName);      
    });

    const pwSacDto: PwSacDto = this.buildDtoFromForm();

    this.pwService.create(pwSacDto).subscribe({
      next: (data) => {
        this.numberPAT = String(data.id);
        this.msgFeedback = true;
        this.createProducts(data);
        this.isSubmitting = false;
      },
      error: (err) => {
        console.log('Erro ao criar PAT', err);
        this.isSubmitting = false;
      }
    });
  }

  createProducts(pwResponse: PWSacResponseDto) {
    const products: PWProductDto[] = this.getProducts();
    products.forEach(product => {
      const pwProductResponse = pwResponse.products.find(
        (p) => p.description === product.description && p.productOrder === product.productOrder
      );
      if (!pwProductResponse) {
        console.warn('Produto não encontrado na resposta para:', product);
        return;
      }
      product.id = pwProductResponse.id;

      this.pwProductService.update(product).then((req$) => {
        req$.subscribe({
          next: (res) => console.log('success in send product', res),
          error: (err) => console.error('Error in send product', err)
        });
      });
    })
  }

  newSubmiteFunc() {
    this.msgFeedback = !this.msgFeedback;
    window.location.reload();
  }


  checkFormValidation(): void {
    if (this.pwForm.invalid) {
      Object.keys(this.pwForm.controls).forEach(field => {
        const control = this.pwForm.get(field);
        if (control?.invalid) {
          console.log(`Campo "${field}" está inválido.`);
        }
      });
    }
  }

  resetTires() {
    this.tires.set([{ name: 'PNEU', url: null }]);
    this.selectedTireIndex.set(null);
  }

  get tiresArray(): FormArray {
    return this.pwForm.get('tires') as FormArray;
  }

  addTire(): void {
    const tiresFormArray = this.tiresArray;
    if (tiresFormArray.length < this.maxTiresAllowed) {
      tiresFormArray.push(this.createTireFormGroup());
      this.updateProductQuantity();
    }
  }

  private createTireFormGroup(): FormGroup {
    return this.fb.group({
      customerAllegation: ['', Validators.required],
      hasAnalyse: ['N', Validators.required],
      additionalInformation: [''],
      type: [''], // SPECIAL | NORMAL
      images: this.fb.array([
        this.fb.group({ name: 'DOT', url: [null, Validators.required] }),
        this.fb.group({ name: 'PNEU', url: [null, Validators.required] }),
        this.fb.group({ name: 'BANDA DE RODAGEM', url: [null, Validators.required] }),
        this.fb.group({ name: 'DANO', url: [null, Validators.required] })
      ], Validators.required)
    });
  }


  removeTire(index: number): void {
    const tiresFormArray = this.tiresArray;
    tiresFormArray.removeAt(index);
    this.updateProductQuantity();

    if (this.selectedTireIndex() === index) {
      this.selectedTireIndex.set(null);
    }
  }

  private updateProductQuantity(): void {
    const tiresFormArray = this.tiresArray;
    this.pwForm.get('productQuantity')?.setValue(tiresFormArray.length);
  }


  onModalClosed(result: any): void { 
    console.log('Modal result:', result);
    
    // Se o usuário clicou em confirmar no modal de privacidade, marca o checkbox
    if (result?.id === 'privacy-policy-modal' && result?.action === 'confirm') {
      this.privacyAccepted = true;
      this.onPrivacyChange(true);
      this.cdRef.detectChanges();
    }
    
    // Também verifica se result é string 'confirm' (alguns modais retornam assim)
    if (typeof result === 'string' && result === 'confirm') {
      this.privacyAccepted = true;
      this.onPrivacyChange(true);
      this.cdRef.detectChanges();
    }
  }

  openModal(index: number): void {
    this.selectedTireIndex.set(index);

    this.imagesFormArray = this.getImagesFormArray(this.selectedTireIndex());

    const addInfoValue = this.getTireForm(index).get('additionalInformation')?.value || '';
    this.remainingAdditionalInfoCharacters = this.maxLengthAdditionalInfoCharacters - addInfoValue.length;

    setTimeout(() => {
      if (this.contentModal) {
        // Detectar se é mobile (largura <= 768px)
        const isMobile = window.innerWidth <= 768;
        const modalWidth = isMobile ? 300 : 900;
        
        this.myModal.open({
          id: `modal-pneu-${index}`,
          width: modalWidth,
          title: '',
          content: this.contentModal,
          confirm: 'Ok'
        });
      } else {
        console.warn('contentModal ainda está undefined');
      }
    });
  }

  getTireForm(tireIndex: number): FormGroup {
    const tireFormGroup = (this.pwForm.get('tires') as FormArray).at(tireIndex) as FormGroup;
    return tireFormGroup;
  }

  updateImage(tireIndex: number, indexImage: number, imageUrl: string): void {
    const imagesArray = this.getImagesFormArray(tireIndex);
    if (imagesArray) {
      imagesArray.at(indexImage).patchValue({ url: imageUrl });
    } else {
      console.error('FormArray de imagens não encontrado.');
    }
  }

  addMorePhotos(tireIndex: number): void {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';

    input.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target?.files?.length > 0) {
        this.loadNewImage(target.files[0], tireIndex);
      }
    };

    input.click();
  }

  loadNewImage(file: File, tireIndex: number): void {
    const reader = new FileReader();
    reader.onload = () => {
      const newImage = { name: 'FOTO ADICIONAL: ' + file.name, url: reader.result as string };
      const tiresFormArray = this.pwForm.get('tires') as FormArray;
      const tireForm = tiresFormArray.at(tireIndex) as FormGroup;
      const imagesArray = tireForm.get('images') as FormArray;

      imagesArray.push(this.fb.group(newImage));
    };

    reader.readAsDataURL(file);
  }

  validateDocument() {
    const document: string = this.pwForm.get('customer.document')?.value;

    if (document?.trim()) {
      this.isLoadingDocument = true;
      this.documentService.validate(document).subscribe({
        next: (res) => {
          this.isLoadingDocument = false;
          console.log('Documento válido:', res);
        },
        error: (err) => {
          this.isLoadingDocument = false;
          console.error('Erro na validação do documento:', err);
          this.pwForm.get('customer.document')?.setErrors({ invalidDocument: true });
        }
      });
    }
  }

  onBrandSelected(selectedBrandName: string) {
    const selected = this.vehicleBrandList.find(b => b.name === selectedBrandName);
    this.pwForm.get('vehicle.brand')?.setValue(selected);
  }

 private renderCaptchaIfPossible(): void {
    if (
      this.captchaContainer &&
      this.captchaContainer.nativeElement &&
      (window as any).grecaptcha &&
      (window as any).grecaptcha.render &&
      this.captchaWidgetId === null
    ) {
      try {
        this.captchaWidgetId = grecaptcha.render(
          this.captchaContainer.nativeElement,
          {
            sitekey: this.siteKey,
            callback: (token: string) => this.onCaptchaResolved(token),
          }
        );
      } catch (error) {
        console.error('Erro ao renderizar reCAPTCHA:', error);
      }
    }
  }

  onCaptchaResolved(token: string | null): void {
    this.pwForm.get('recaptcha')?.setValue(token);
    if (token) {
      this.captchaVerified = true;
      // Após 3 segundos, muda para visualização minimalista
      setTimeout(() => {
        this.captchaMinimalist = true;
      }, 3000);
    }
  }

  updateCountdown(): void {
    const descControl = this.pwForm.get('allegation.description');
    const value = descControl?.value || '';

    if (value.length > this.maxLength) {
      descControl?.setValue(value.substring(0, this.maxLength));
      this.remainingCharacters = 0;
    } else {
      this.remainingCharacters = this.maxLength - value.length;
    }
  }

  updateAdditionalInfoCountdown(): void {
    const tireForm = this.getTireForm(this.selectedTireIndex());
    const addInfoControl = tireForm?.get('additionalInformation');
    const value = addInfoControl?.value || '';

    if (value.length > this.maxLengthAdditionalInfoCharacters) {
      addInfoControl?.setValue(value.substring(0, this.maxLengthAdditionalInfoCharacters));
      this.remainingAdditionalInfoCharacters = 0;
    } else {
      this.remainingAdditionalInfoCharacters = this.maxLengthAdditionalInfoCharacters - value.length;
    }
  }

  hasAnalyse(flag: string){
    const tireForm = this.getTireForm(this.selectedTireIndex());
    const addInfoControl = tireForm.get('additionalInformation');    
    if (flag === 'Y'){
      this.addInfoLabel = 'Insira aqui a revenda, a data e faça um breve relato sobre o dano alegado: (Obrigatório) *';      
      addInfoControl?.setValidators([Validators.required]);
    } else {
      this.addInfoLabel = 'Informações Adicionais (opcional)';
      addInfoControl?.clearValidators();
    }
    addInfoControl?.updateValueAndValidity();
  }

  openPrivacyModal(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    // Detectar se é mobile (largura <= 768px)
    const isMobile = window.innerWidth <= 768;
    const modalWidth = isMobile ? 500 : 900;
    
    if (this.privacyPolicyModal) {
      this.myModal.open({
        id: 'privacy-policy-modal',
        width: modalWidth,
        title: 'Política de Privacidade',
        content: this.privacyPolicyModal,
        confirm: 'Confirmar',
        cancel: 'Fechar'
      });
    }
  }

}